
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/pages/refer-a-friend",
      function () {
        return require("private-next-pages/[locale]/pages/refer-a-friend/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/pages/refer-a-friend"])
      });
    }
  